import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../category.service';
import { Category } from '../category';
import { Router } from '@angular/router';


@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css'],
  providers: [CategoryService]
})
export class CategoryComponent implements OnInit {

	categories: Category[];
  loading: boolean = false;
  result: any = [];


  constructor(private categoryService: CategoryService,private router: Router) { }

   ngOnInit() {
    this.loading = true;
	  this.categoryService.getCategory().subscribe(response=>{
                                                this.recarray(response['data'],'children',this);
                                                
                                                this.categories=this.result.map(data=>{
                                                                                  return {
                                                                                          id: data.id,
                                                                                          name: data.name, 
                                                                                          parent_id: this.getParentCategory(data,data.parent_id),
                                                                                          available: data.available,
                                                                                          position: data.position
                                                                                         }
                                                                                  });
                                                this.loading=false;
                                              });

  }
  create():void{
	   this.router.navigate(['/dashboard/category-crud']); 	
  }

  edit(id: any):void{
    console.log("ha");
     this.router.navigate(['/dashboard/category-crud/',id]);
  }


      getParentCategory(array: any[],id: any){
        let tmp = this.result.filter(data=>{
          return id==data.id;
        });
        if(tmp instanceof Array && tmp.length==1){
          if("name" in tmp[0]){
               return tmp[0]['name'];
          }else{
               return "";           
          }
        }
      }

      recarray(ar: any, searchfor: any,that: any) {
          ar.forEach(function(item: any,i: any,arr: any){
              if(item instanceof Object){
                  if("children" in item){
                     that.recarray(item['children'],searchfor,that)
                  }
                  that.result.push(item);
              }
          });
    }
}


// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/categories/category/category.component.ts